import type { RootState } from '..';

export const list = (state: RootState) => state.monitoringSystem.list;
